<div class="row">
    <div class="col-sm-12">
    <h1 class="text-center"> Our Story</h1>
    <div class="timeline">
        <app-time-line-six></app-time-line-six>
        <app-time-line-five></app-time-line-five>
        <app-time-line-four></app-time-line-four>
        <app-time-line-three></app-time-line-three>
        <app-time-line-two></app-time-line-two>
        <app-time-line-one></app-time-line-one>
    </div>
    </div>
    </div>
    <app-country-level-syllabus></app-country-level-syllabus>
